import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { CallmeComponent } from './callme/callme.component';
import { HeaderComponent } from './header/header.component';
import { ProjectsComponent } from './projects/projects.component';


const routes: Routes = [
  { path: 'aboutus', component: AboutUsComponent },
  { path: 'Home', component: HeaderComponent },
  { path: 'project', component: ProjectsComponent },
  { path: 'contact', component: CallmeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
